import { createRoutine } from 'redux-saga-routines';
import { takeLatest, call, put, select, StrictEffect } from 'redux-saga/effects';
import { get } from 'lodash/fp';
import api, { API_HOST } from '../helpers/api';
import { LoadPartnerMessagesPayloadType } from '../helpers/types';

export const loadPartnerMessages = createRoutine('intl/LOAD_PARTNERS_MESSAGES');

function* handleLoadPartnerMessages({
  payload: { partnerSlug },
}: LoadPartnerMessagesPayloadType): Generator<StrictEffect, void, any> {
  try {
    const locale = yield select(get('intl.locale'));
    const searchParams = new URLSearchParams({ language: locale });
    const currentMessages = yield select(get('intl.messages'));
    const partnerMessages = yield call(
      api.get,
      `${API_HOST}/messages/partners/${partnerSlug}/?${searchParams}`,
      false,
    );
    yield put(loadPartnerMessages.request());
    yield put({
      type: '@@intl/UPDATE',
      payload: {
        messages: {
          ...currentMessages,
          ...partnerMessages,
        },
      },
    });
    yield put(loadPartnerMessages.success());
  } catch (error) {
    yield put(loadPartnerMessages.failure(error));
  } finally {
    yield put(loadPartnerMessages.fulfill());
  }
}

export function* intlSaga() {
  yield takeLatest(loadPartnerMessages.TRIGGER, handleLoadPartnerMessages);
}
